import React from "react";
import styled from "styled-components";

import {
  CDropdownButton,
  Text,
  Box,
  CFontIcon
} from "@appcues/component-library";

import { iconAllUrl } from "constants/segments";

const learnLifecycleUrl = "https://appcues.com/product-led-growth-flywheel";
const lifecycleTourFlowId = "-Lio4es2yK4lIe_HHsjc";
const feedbackTourFlowId = "-Lio6a1yg0vGU3O2H8fz";

const handleTourClick = () => {
  window.Appcues.show(lifecycleTourFlowId);
};
const handleFeedbackClick = () => {
  window.Appcues.show(feedbackTourFlowId);
};

const dropdownOptions = [
  <Text key="tour" onClick={handleTourClick}>
    <CFontIcon
      className="fas fa-question-circle"
      altText="help icon"
      color="$purple"
      marginRight="12px"
    />
    Take a tour
  </Text>,
  <Text key="learn" paddingLeft="27px">
    <Box
      is="a"
      href={learnLifecycleUrl}
      color="inherit"
      textDecoration="none"
      target="_blank"
    >
      <Box
        is="img"
        src={iconAllUrl}
        alt="user lifecycle icon"
        marginRight="5px"
        position="absolute"
        top="8px"
        left="20px"
      />
      Learn about the lifecycle
    </Box>
  </Text>,
  <Text key="feedback" onClick={handleFeedbackClick}>
    <CFontIcon
      className="fas fa-comment-alt"
      altText="comment icon"
      color="$yellow-dark"
      marginRight="12px"
    />
    Send us feedback
  </Text>
];

const LearnMoreButton = () => {
  return (
    <StyledCDropdownButton
      float="right"
      options={dropdownOptions}
      paddingRight="16px"
    >
      <Box
        is="img"
        src={iconAllUrl}
        alt="user lifecycle icon"
        marginRight="10px"
      />
      Learn More
    </StyledCDropdownButton>
  );
};
export default LearnMoreButton;

const StyledCDropdownButton = styled(CDropdownButton)`
  line-height: 24px;

  button {
    padding-left: 12px;
  }

  .menu {
    padding-top: 17px;
    padding-bottom: 18px;

    li {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
`;
